module.exports = __webpack_public_path__ + "static/media/attack_lines.9d85f29d.png";